import { createSignal } from '@funtech-int/rival';
import { useSignal } from '@funtech-int/rival-react';

import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';
import { useVolume } from '@/scenarios/legacy-player/hooks/useVolume';

const soundPreferencesVolume = createSignal(51);
export const soundPreferencesMute = createSignal(false);

const useSoundPreferencesVolume = () => useSignal(soundPreferencesVolume);
const useSoundPreferencesMute = () => useSignal(soundPreferencesMute);

export const useSoundPreferencesWatcher = () => {
    const { setVolume } = useVolume();
    const savedVolume = useSoundPreferencesVolume();
    const savedMuted = useSoundPreferencesMute();

    useInstanceEffect((instance) => {
        setVolume(savedVolume);
        instance.setIsMuted(savedMuted);
    });

    useInstanceEffect((instance) =>
        instance.onVolumeChange((volume) => {
            soundPreferencesVolume.set(volume);
        })
    );
};
